import React, { useEffect } from "react";
export default (function (targetRef, callback, options) {
  useEffect(function () {
    var finalOptions = options || {
      root: null,
      rootMargin: "0px",
      threshold: 0.25
    };
    var observer = new IntersectionObserver(callback, finalOptions);

    if (targetRef && targetRef.current) {
      observer.observe(targetRef.current);
    }

    return function () {
      if (targetRef && targetRef.current) observer.unobserve(targetRef.current);
    };
  }, [targetRef, callback, options]);
});